export const NAME = 'paymentSession'

export const PENDING = `${NAME}/PENDING`

export const SUCCESS = `${NAME}/SUCCESS`

export const ERROR = `${NAME}/ERROR`